var Backbone = require('backbone');

var Base = require('front/components/Base/Base');

require('./IndexPartners.less');

module.exports = Base.extend({
    template: require('./IndexPartners.jinja'),

    el: '.IndexPartners',

    events: {
        'click .IndexPartners-btn': 'onBtnClick',
        'click .IndexPartners-popupBackground': 'onPopupBackgroundClick'
    },

    initialize: function (options) {
        this.$btn = this.$('.IndexPartners-btn');
        this.$popup = this.$('.IndexPartners-popup');

        Base.prototype.initialize.call(this, options);
    },

    viewsRegistration: function () {
    },

    onBtnClick: function () {
        this.$btn.addClass('IndexPartners-btn--isActive');

        this.$popup.show();
        this.$popup.addClass('IndexPartners-popup--isActive');
    },

    onPopupBackgroundClick: function () {
        this.$btn.removeClass('IndexPartners-btn--isActive');
        this.$popup.removeClass('IndexPartners-popup--isActive');

        setTimeout(function () {
            this.$popup.hide();
        }.bind(this), 300);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/IndexPartners/IndexPartners.js
// module id = 53
// module chunks = 0